import type {
    CreatureSkillRawPoints,
    CreatureSkillTierCompileInput,
    CreatureSkillTierCompileResult,
    SkillTierCatalogEntry,
} from '../types';

export function getSkillTierFromPoints(
    totalSkillPoints: number,
    tierCatalog: readonly SkillTierCatalogEntry[],
): { tier: string; level: number } {
    const total = Math.trunc(totalSkillPoints);
    if (total <= 0) return { tier: 'skill_tier_0', level: 0 };
    for (let index = tierCatalog.length - 1; index >= 0; index -= 1) {
        const tier = tierCatalog[index];
        if (tier && total >= Math.trunc(tier.sp_required)) {
            return { tier: tier.variable_name, level: Math.trunc(tier.skill_tier_level) };
        }
    }
    return { tier: 'skill_tier_1', level: 1 };
}

/** Pure Slice 4 tier decision from build_caster_skills(); decoration and source walks stay outside. */
export function compileCreatureSkillTier(input: CreatureSkillTierCompileInput): CreatureSkillTierCompileResult {
    let rawSp: CreatureSkillRawPoints | null = null;
    if (input.skillPoints !== null) {
        const allocated = Math.trunc(input.skillPoints.allocated);
        const training = Math.trunc(input.skillPoints.training);
        const ascension = Math.trunc(input.skillPoints.ascension);
        const total = allocated + training + ascension;
        if (total > 0) rawSp = { allocated, training, ascension, total };
    }

    const hardcodedLevel = Math.max(0, Math.trunc(input.hardcodedLevel));
    const sources: string[] = [];
    if (hardcodedLevel > 0) sources.push('direct_assignment');

    const spLevel = rawSp === null ? 0 : getSkillTierFromPoints(rawSp.total, input.tierCatalog).level;
    let assignedLevel: number;
    if (spLevel > hardcodedLevel) {
        assignedLevel = spLevel;
        sources.push('skill_points');
        if (hardcodedLevel > 0) sources.push('sp_overrode_hardcoded');
    } else if (hardcodedLevel > 0) {
        assignedLevel = hardcodedLevel;
    } else if (spLevel > 0) {
        assignedLevel = spLevel;
        sources.push('skill_points');
    } else {
        assignedLevel = 0;
    }

    if (assignedLevel === 0) {
        if (input.skill.item_type === 'defensive_skill' || input.skill.item_type === 'innate_skill') {
            assignedLevel = 1;
            sources.push('default_defensive');
        } else {
            sources.push('default_flawed');
        }
    }

    return { tier_level: assignedLevel, sources, raw_sp: rawSp };
}
